const middleware = {}

middleware['hidden'] = require('../../middleware/hidden.js')
middleware['hidden'] = middleware['hidden'].default || middleware['hidden']

export default middleware
